"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "wrapper": "wrapper_19rtJ6",
  "icon": "icon_1ZiSbI"
}; 
require('./AssetType.css');
var AssetType = function AssetType(_ref) {
  var type = _ref.type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'xs' : _ref$size,
    ariaHidden = _ref.ariaHidden;
  var assetTypesConfiguration = (0, _react.useContext)(_exchangeReactHooks.AssetTypesConfigurationContext);
  var typeConfiguration = assetTypesConfiguration[type] ? assetTypesConfiguration[type] : assetTypesConfiguration.default;
  var TypeIcon = typeConfiguration.icon;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: styles.wrapper,
    title: "Asset type",
    "data-test-id": "asset-type",
    "aria-hidden": ariaHidden
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: size,
    className: styles.icon,
    "aria-hidden": true
  }, /*#__PURE__*/_react.default.createElement(TypeIcon, null)), typeConfiguration.name);
};
var _default = exports.default = AssetType;
//# sourceMappingURL=AssetType.js.map